<template>
  <div
    class="plane-order-detail"
    :class="{ isiOSX: isiOSX }"
    v-if="info.list_extend"
  >
    <van-nav-bar title="订单详情" left-arrow @click-left="reBack" />
    <van-row class="order-status">
      <van-col class="status" span="24">
        <p class="state">
          <span v-show="info.list_extend.status == -3">已退票</span>
          <span
            v-show="
              info.list_extend.status == -2 || info.list_extend.status == -1
            "
            >已取消</span
          >
          <span v-show="info.list_extend.status == 1"
            >待支付（{{ downCount }}）</span
          >
          <span
            v-show="
              info.list_extend.status == 2 || info.list_extend.status == 6
            "
            >确认中</span
          >
          <span v-show="info.list_extend.status == 3">确认失败</span>
          <span v-show="info.list_extend.status == 4">已出票</span>
          <span v-show="info.list_extend.status == 5">交易完成</span>
          <span class="right"
            >总价：<span class="price"
              >￥<span class="money">{{ money1 }}</span
              >.{{ money2 }}</span
            ></span
          >
        </p>
        <p class="tip" v-show="info.list_extend.status == 4">
          已出票，待您前往机场取票（机票积分在落地之后两小时内结算）
        </p>
        <p class="tip" v-show="info.list_extend.status == 2">
          您的订单待确认，请稍等
        </p>
        <p class="tip" v-show="info.list_extend.status == 1">
          请在规定时间内支付，超时自动取消订单
        </p>
        <p class="tip" v-show="info.list_extend.status == 3">
          您的订单失效，请重新预定
        </p>
        <p
          class="tip"
          v-show="
            info.list_extend.status == -2 || info.list_extend.status == -1
          "
        >
          订单已取消。如您已支付，金额将原路退回
        </p>
        <p class="tip" v-show="info.list_extend.status == -3">
          您已退票成功，退款会在15个工作日内到账，详情请咨询客服
        </p>
        <p class="tip" v-show="info.list_extend.status == 5">您的交易完成</p>
        <div style="margin-bottom: 8px">
          <!-- <p class="orderNumber">订单号：{{ info.list_extend.xb_order_sn }}</p> -->
          <p class="orderNumber">
            订单号：<span ref="copytxt">{{
              info.list_extend.external_order_sn
            }}</span>
            <span
              style="font-size: 12px; color: #1989fa; margin-left: 15px"
              @click="copyCode()"
              >复制</span
            >
          </p>
        </div>
        <p class="btn" v-show="info.list_extend.status == 1">
          <span class="right" @click="toPay()">立即支付</span>
          <span class="left" @click="showPopup()">取消订单</span>
        </p>
        <p class="btn" v-show="info.list_extend.status == 5">
          <span
            class="right"
            @click="purchase()"
            v-show="info.list_extend.invoice_status == 1"
            >申请发票</span
          >
          <span
            class="right status"
            v-show="info.list_extend.invoice_status == 2"
            >申请中</span
          >
          <span
            class="right status"
            v-show="info.list_extend.invoice_status == 3"
            >发票已开具</span
          >
          <span
            class="right status"
            v-show="info.list_extend.invoice_status == -1"
            >已驳回</span
          >
        </p>
        <p
          class="btn"
          v-show="info.list_extend.status == 4 && canGetCredit == 1"
        >
          <span
            class="left"
            @click="settlement()"
            v-show="info.list_extend.giving_credits_status == 1"
            >领取积分</span
          >
        </p>
      </van-col>
    </van-row>
    <van-row class="allList">
      <van-cell>
        <div class="oilList" :style="liststyle">
          <p class="company">
            <span class="time">{{
              departureTime(info.list_extend.order_flight_info.depart_date)
            }}</span>
            <span class="space"
              >{{ info.list_extend.order_flight_info.depart_city_name
              }}<span></span
              >{{ info.list_extend.order_flight_info.arrive_city_name }}</span
            >
            <span
              style="
                font-size: 12px;
                color: rgb(25, 137, 250);
                margin-left: 15px;
              "
              v-if="info.list_extend.order_flight_info.baggage_info"
              @click="
                luggageRule(info.list_extend.order_flight_info.baggage_info)
              "
              >免费行李规定 ></span
            >
          </p>
          <div class="airline">
            <p>
              <span class="edge">
                <span class="city">{{
                  info.list_extend.order_flight_info.depart_city_name
                }}</span>
                <span class="time">{{
                  info.list_extend.order_flight_info.depart_time
                }}</span>
                <span class="airport"
                  >{{ info.list_extend.order_flight_info.depart_airport_name
                  }}{{
                    info.list_extend.order_flight_info.depart_airport_terminal
                  }}</span
                >
              </span>
              <span class="middle">
                <span>{{
                  info.list_extend.order_flight_info.flight_time
                }}</span>
                <img
                  v-if="
                    info.list_extend.order_flight_info.stop_num == 0 ||
                    info.list_extend.order_flight_info.stop_info.length == 0
                  "
                  src="../../assets/plane/aircraft.png"
                />
                <img
                  v-if="
                    info.list_extend.order_flight_info.stop_num != 0 &&
                    info.list_extend.order_flight_info.stop_info.length != 0 &&
                    !info.list_extend.order_flight_info.stop_info[0].flight_no1
                  "
                  src="../../assets/plane/stop.png"
                />
                <img
                  v-if="
                    info.list_extend.order_flight_info.stop_num != 0 &&
                    info.list_extend.order_flight_info.stop_info.length != 0 &&
                    info.list_extend.order_flight_info.stop_info[0].flight_no1
                  "
                  src="../../assets/plane/stop_long.png"
                />
              </span>
              <span class="edge">
                <span class="city">{{
                  info.list_extend.order_flight_info.arrive_city_name
                }}</span>
                <span class="time">{{
                  info.list_extend.order_flight_info.arrive_time
                }}</span>
                <span class="airport"
                  >{{ info.list_extend.order_flight_info.arrive_airport_name
                  }}{{
                    info.list_extend.order_flight_info.arrive_airport_terminal
                  }}</span
                >
              </span>
            </p>
          </div>
          <p class="msg">
            {{ info.list_extend.order_flight_info.seat_name
            }}<span class="border"></span
            ><img
              :src="info.list_extend.order_flight_info.air_comImage_url"
            />{{ info.list_extend.order_flight_info.company_name }}
            {{ info.list_extend.order_flight_info.flight_no
            }}<span class="border"></span
            >{{
              info.list_extend.order_flight_info.craft_type_name ||
              info.list_extend.order_flight_info.craft_type
            }}
            <span v-if="info.list_extend.order_flight_info.plane_model"
              >(<span v-if="info.list_extend.order_flight_info.plane_model == 1"
                >大</span
              ><span v-if="info.list_extend.order_flight_info.plane_model == 2"
                >中</span
              ><span v-if="info.list_extend.order_flight_info.plane_model == 3"
                >小</span
              ><span v-if="info.list_extend.order_flight_info.plane_model == 0"
                >其他</span
              >)</span
            >
            <span v-else>(其他)</span>
          </p>
        </div>
      </van-cell>
    </van-row>
    <van-row class="aircrewInformation" v-if="info.list_extend.order_guest">
      <van-col
        span="24"
        class="marginB"
        v-for="(item, index) in info.list_extend.order_guest"
        :key="index"
      >
        <p><span>乘机人</span>{{ item.username }}</p>
        <p><span>证件号</span>{{ item.id_number }}</p>
      </van-col>
    </van-row>
    <van-row class="aircrewInformation">
      <van-col span="24">
        <p><span>联系人</span>{{ info.list_extend.contact_name }}</p>
        <p><span>联系电话</span>{{ info.list_extend.contact_mobile }}</p>
      </van-col>
    </van-row>
    <van-popup v-model="show">
      <div class="box">
        <img src="../../assets/common/BG@2x.png" alt="" />
        <p class="title">温馨提示</p>
        <p class="tips">亲，您真的要取消该订单吗？</p>
        <span class="left" @click="cancle()">取消</span>
        <span class="right" @click="confirm()">确认</span>
      </div>
    </van-popup>
    <van-popup class="tipMSG" v-model="showTip">
      <div class="box">
        <img src="../../assets/common/BG@2x.png" alt="" />
        <p class="title">您已提交申请，请勿重复操作</p>
        <p class="tips">积分预计两小时内到账，详情请咨询客服</p>
        <span class="right_big" @click="tipHide()">确定</span>
      </div>
    </van-popup>
    <van-popup v-model="luggagePop" position="bottom" :overlay="true">
      <img
        class="close"
        @click="closePopup"
        src="../../assets/plane/close-icon@2x.png"
      />
      <van-row class="popBox">
        <van-col class="title" span="24">免费行李规定</van-col>
        <van-col class="tip" span="24"
          >若您在机场以外发生行李丢失或延迟，请及时联系销巴生活客服，我们将尽力协助您找回行李。若携带行李超重，逾重部分的收费标准以航司规定为准。</van-col
        >
        <van-col class="title title1" span="24">托运行李</van-col>
        <van-col class="tip1" span="24">{{ luggageInfo }}</van-col>
      </van-row>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      liststyle: {
        width: document.body.clientWidth - 40 + "px",
      },
      info: {},
      show: false,
      money1: 0,
      money2: 0,
      isiOSX: false,
      order_sn: "",
      orderInfo: {},
      purchaseInfo: {},
      downCount: "00:00",
      canGetCredit: 0,
      showTip: false,
      luggagePop: false,
      luggageInfo: "",
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.$api
        .post("/order/member/order/detail", {
          order: { type: "air" },
          ordersn: this.$route.query.ordersn,
        })
        .then((res) => {
          var l = res.list_extend.pay_money.length;
          this.money1 = res.list_extend.pay_money.substr(0, l - 3);
          this.money2 = res.list_extend.pay_money.substr(l - 2, 2);
          var flight_time = res.list_extend.order_flight_info.flight_time;
          var hh = Math.floor(flight_time / 60 / 60);
          var mm = (flight_time - hh * 60 * 60) / 60;
          res.list_extend.order_flight_info.flight_time =
            hh + "小时" + mm + "分钟";
          this.order_sn = res.list_extend.xb_order_sn;
          this.info = res;
          //是否可领取积分
          var arrival_time =
            res.list_extend.order_flight_info.arrive_date +
            " " +
            res.list_extend.order_flight_info.arrive_time +
            ":00";
          var current = Math.floor(new Date().getTime() / 1000);
          var diff = this.date2timestamp(arrival_time) - current + 2 * 60 * 60;
          if (diff <= 0) {
            this.canGetCredit = 1;
          }

          res.main_order.ordersn = res.list_extend.xb_order_sn;
          this.orderInfo = JSON.stringify(res.main_order);
          this.purchaseInfo = {
            order_number: this.$route.query.ordersn,
            actual_amount: res.main_order.actual_amount,
            order_amount: res.main_order.order_amount,
            order_company_name: res.list_extend.order_flight_info.company_name,
            original_price: res.list_extend.original_price,
          };
          var not_pay_cancel_time = res.list_extend.not_pay_cancel_time;
          if (not_pay_cancel_time) {
            this.setTimer(this.date2timestamp(not_pay_cancel_time));
          }
        });
    },
    setTimer(end_time) {
      var _that = this;
      var current = Math.floor(new Date().getTime() / 1000);
      var ts = end_time - current;
      if (ts <= 0) {
        _that.downCount = "00:00";
        clearInterval(timer);
        if (this.info.list_extend.status == 1) {
          this.info.list_extend.status = -2;
        }

        return false;
      } else {
        _that.getTimeCount(ts, _that);
      }
      var timer = setInterval(function () {
        var current = Math.floor(new Date().getTime() / 1000);
        var ts = end_time - current;
        if (ts <= 0) {
          _that.downCount = "00:00";
          clearInterval(timer);
          _that.getInfo();
        } else {
          _that.getTimeCount(ts, _that);
        }
      }, 1000);
    },
    //支付时间倒计时
    getTimeCount(ts, _that) {
      var mm = parseInt((ts / 60) % 60, 10);
      var ss = parseInt(ts % 60, 10);
      this.downCount = _that.checkTime(mm) + ":" + _that.checkTime(ss);
    },
    //申请发票
    purchase() {
      this.params(
        JSON.stringify(this.purchaseInfo),
        JSON.stringify(this.purchaseInfo),
        "purchase"
      );
    },
    //领取积分
    settlement() {
      this.$api
        .post("/order/member/order/settle", { ordersn: this.order_sn })
        .then((res) => {
          this.$toast("领取成功");
          // this.info.list_extend.status = 5;
          this.getInfo();
        })
        .catch((err) => {
          if (err.code == 99998) {
            this.showTip = true;
          }
        });
    },
    tipHide() {
      this.showTip = false;
    },
    cancle() {
      this.show = false;
    },
    confirm() {
      this.show = false;
      this.$api
        .post("/order/member/order/cancel", { ordersn: this.order_sn })
        .then((res) => {
          this.getInfo();
        });
    },
    toPay() {
      this.params(this.orderInfo, this.orderInfo, "toPay");
    },
    reBack() {
      this.$router.go(-1);
    },
    showPopup() {
      this.show = true;
    },
    substr(par) {
      return par.substr(11, 5);
    },
    departureTime(params) {
      var date = new Date(params);
      var mouth = date.getMonth() + 1;
      var day = date.getDate();
      var week = date.getDay();
      switch (week) {
        case 1:
          week = "周一";
          break;
        case 2:
          week = "周二";
          break;
        case 3:
          week = "周三";
          break;
        case 4:
          week = "周四";
          break;
        case 5:
          week = "周五";
          break;
        case 6:
          week = "周六";
          break;
        default:
          week = "周日";
      }
      return (
        (mouth < 10 ? "0" + mouth : mouth) +
        "-" +
        (day < 10 ? "0" + day : day) +
        " " +
        " " +
        week
      );
    },
    copyCode() {
      const rechage_range = document.createRange();
      rechage_range.selectNode(this.$refs.copytxt);
      const rechage_selection = window.getSelection();
      if (rechage_selection.rangeCount > 0) rechage_selection.removeAllRanges();
      rechage_selection.addRange(rechage_range);
      document.execCommand("Copy");
      this.$toast("复制成功");
      rechage_selection.removeAllRanges();
    },
    closePopup() {
      this.luggagePop = false;
    },
    luggageRule(info) {
      if (info) {
        let len = info.length;
        if (
          !/^([\u4E00-\uFA29]|[\uE7C7-\uE7F3]|[a-zA-Z0-9_-])$/.test(
            info.substr(len - 2, 1)
          )
        ) {
          this.luggageInfo = info.substr(0, len - 2) + ";";
        } else {
          this.luggageInfo = info;
        }
        this.luggagePop = true;
      }
    },
  },
};
</script>

<style lang="less">
.plane {
  &-order-detail {
    background: #f2f2f2;
    height: 100%;
    padding-top: 71px;
    .van-popup--bottom {
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      height: 352px;
      padding-top: 62px;
      overflow: hidden;
      .close {
        width: 22px;
        text-align: left;
        position: absolute;
        top: 20px;
        left: 15px;
        z-index: 2009;
      }
      .popBox {
        padding: 0 15px;
        height: 100%;
        overflow-y: scroll;
        .title {
          color: #333;
          font-size: 18px;
          text-align: left;
          height: 25px;
          line-height: 25px;
          margin: 6px 0 10px;
          font-weight: 700;
        }
        .tip {
          color: #999;
          font-size: 15px;
          line-height: 23px;
        }
        .title1 {
          font-size: 16px;
          margin-top: 20px;
        }
        .tip1 {
          color: #333;
          font-size: 16px;
          line-height: 25px;
          padding-bottom: 40px;
        }
      }
    }
    .van-nav-bar {
      background: #f2f2f2;
      padding-top: 24px;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      .van-nav-bar__title {
        font-size: 18px;
        color: #333;
      }
      .van-icon-arrow-left:before {
        display: none;
      }
      .van-nav-bar__left {
        left: 11px;
        .van-icon {
          width: 17px;
          height: 15px;
          display: inline-block;
          background: url(../../assets/plane/reBack.png) no-repeat center center;
          background-size: 100% 100%;
        }
      }
    }
    .van-hairline--bottom::after {
      border: none;
    }
    .order-status {
      color: #999;
      font-size: 10px;
      padding: 0 11px;
      margin-bottom: 7px;
      .status {
        padding: 10px 10px 0;
        background: #fff;
        border-radius: 10px;
        .state {
          color: #333;
          font-size: 15px;
          height: 24px;
          line-height: 24px;
          overflow: hidden;
          .right {
            float: right;
            font-size: 10px;
            .price {
              color: #e6212f;
              font-size: 9px;
              .money {
                font-size: 15px;
              }
            }
          }
        }
        .tip {
          line-height: 20px;
        }
        .orderNumber {
          height: 22px;
          line-height: 22px;
        }
        .btn {
          span {
            float: right;
            width: 81px;
            height: 26px;
            line-height: 26px;
            border: solid 1px #ff6059;
            border-radius: 7px;
            color: #ff6059;
            text-align: center;
            margin-top: 7px;
            margin-bottom: 14px;
          }
          .right {
            color: #fff;
            background: #ff6059;
            margin-left: 12px;
          }
          .status {
            background: #ffa09b;
            padding: 0;
            border: solid 1px #ffa09b;
          }
        }
      }
    }
    .allList {
      padding: 0 11px;
      background: #f2f2f2;
      .van-cell {
        background: #fff;
        border-radius: 10px;
        margin-bottom: 7px;
        box-shadow: #e3e3e3 2px 0 4px;
        padding: 0 0 0 10px;
        position: relative;
        .oilList {
          .company {
            color: #333;
            font-size: 14px;
            height: 36px;
            line-height: 35px;
            overflow: hidden;
            border-bottom: solid 1px #f2f2f2;
            .time {
              color: #333;
            }
            .space {
              margin-left: 14px;
              span {
                width: 20px;
                height: 1px;
                display: inline-block;
                margin: 0 2px;
                vertical-align: middle;
                border-bottom: solid 1px #333;
              }
            }
          }
          .airline {
            text-align: center;
            span {
              display: inline;
              text-align: center;
              color: #666;
              font-size: 13px;
            }
            .edge {
              text-align: center;
              display: inline-block;
              span {
                display: inline-block;
              }
              .city {
                color: #333;
                font-size: 17px;
                height: 34px;
                line-height: 34px;
                margin-top: 13px;
                display: block;
              }
              .time {
                height: 18px;
                line-height: 18px;
                display: block;
              }
              .airport {
                height: 19px;
                line-height: 19px;
                margin-bottom: 20px;
                display: block;
              }
            }
            .middle {
              width: 97px;
              padding: 0 20px;
              display: inline-block;
              vertical-align: bottom;
              padding-bottom: 25px;
              span {
                width: 97px;
                height: 18px;
                line-height: 19px;
                border-radius: 9px;
                color: #fff;
                font-size: 13px;
                background: #feab7a;
                text-align: center;
                display: inline-block;
                margin-bottom: 16px;
              }
              img {
                width: 97px;
                display: block;
              }
            }
            @media screen and (max-width: 320px) {
              .middle {
                padding: 0 14px 17px 14px;
              }
            }
          }
          .msg {
            height: 34px;
            line-height: 34px;
            border-top: solid 1px #f2f2f2;
            color: #666;
            font-size: 13px;
            text-align: center;
            img {
              width: 14px;
              margin-right: 7px;
              margin-bottom: -2px;
            }
            .border {
              width: 1px;
              height: 14px;
              background: #999;
              margin: 0 9px;
              display: inline-block;
              margin-bottom: -2px;
            }
          }
        }
      }
    }
    .aircrewInformation {
      padding: 0 11px;
      .van-col {
        background: #fff;
        border-radius: 10px;
        box-shadow: #e3e3e3 2px 0 4px;
        padding: 10px;
        p {
          padding-left: 85px;
          height: 28px;
          line-height: 28px;
          color: #333;
          font-size: 13px;
          position: relative;
          span {
            color: #666;
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }
      .marginB {
        margin-bottom: 7px;
      }
    }
    .van-popup--center {
      width: 70%;
      border-radius: 10px;
      .box {
        img {
          display: block;
          width: 100%;
        }
        .title {
          color: #333;
          font-size: 15px;
          font-weight: 600;
          line-height: 47px;
          margin-top: 8px;
          text-align: center;
        }
        .tips {
          color: #333;
          font-size: 13px;
          line-height: 18px;
          text-align: center;
          margin-bottom: 30px;
        }
        span {
          float: left;
          width: 50%;
          border-top: solid 1px #f2f2f2;
          line-height: 43px;
          color: #999;
          font-size: 14px;
          text-align: center;
          display: inline-block;
        }
        .right {
          color: #e6212f;
          width: calc(50% - 1px);
          border-left: solid 1px #f2f2f2;
        }
      }
    }
    .tipMSG {
      width: 70%;
      border-radius: 10px;
      .box {
        .right_big {
          width: 100%;
          line-height: 43px;
          color: #e6212f;
          font-size: 14px;
          text-align: center;
          display: inline-block;
        }
      }
    }
  }
}
.isiOSX {
  padding-top: 91px;
  .van-nav-bar {
    padding-top: 44px;
  }
}
</style> 
